var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecommendedItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5259 0H4.62931C1.78448 0 0 1.98588 0 5.17211V18.323C0 19.2492 0.733327 20 1.63793 20C1.9118 19.9998 2.18135 19.9301 2.42241 19.797L8.03448 16.6814L14.569 19.8147C14.7461 19.8908 14.9456 19.8918 15.1235 19.8173C15.3014 19.7428 15.443 19.599 15.5172 19.4175C15.6268 19.0831 15.494 18.7157 15.1983 18.5349L8.7069 15.4281C8.2828 15.1894 7.76893 15.1894 7.34483 15.4281L1.72414 18.5349C1.65968 18.571 1.5817 18.571 1.51724 18.5349C1.45595 18.4945 1.41993 18.4241 1.42241 18.3495V5.17211C1.43103 2.81553 2.58621 1.47396 4.65517 1.47396H11.5517C14.2069 1.47396 14.5948 3.68049 14.5948 5.00441V5.60459H7.12931C6.9395 5.61149 6.76016 5.69536 6.6308 5.83774C6.50144 5.98012 6.43267 6.16931 6.43966 6.36364C6.44874 6.74968 6.75225 7.06042 7.12931 7.06973H14.569V14.7926C14.569 15.1972 14.8893 15.5252 15.2845 15.5252C15.6763 15.5252 15.9953 15.2025 16 14.8014V5.00441C16 1.91527 14.2931 0 11.5259 0Z",
    fill: "#FC2B6E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedItemIcon);
export default __webpack_public_path__ + "static/media/RecommendedItemIcon.ae93120d0fcb48dfca3e8ca253785668.svg";
export { ForwardRef as ReactComponent };